import { isHomeLandingPath } from "./homeLandingRoutes";
import { isDetailPerformanceRoute, normalizeDetailRoutePathname } from "./detailRouteBootstrap";

// Keep direct-entry classification in public/index.html in sync. These pages
// use application CSS; Bootstrap utilities override their responsive spacing.
export const isModernStyleRoute = (pathname = "/") => {
  const normalizedPath = normalizeDetailRoutePathname(pathname);
  return normalizedPath === "/destinations"
    || isHomeLandingPath(normalizedPath)
    || isDetailPerformanceRoute(normalizedPath);
};
